


import {
  defineComponent,
  PropType,
  onMounted,
  computed,
  reactive,
} from '@vue/composition-api';
import type { StandardReportCar, StandardReport } from '@/models/externalReports/standard/spStandardReport';
import type {
  ExternalReportsLabelSp,
  ExternalReportSettings,
} from '@/models/apis/externalReports/external_report_settings';
import type {
  StandardReportBaseArrivalTsUpdateParams,
} from '@/models/apis/externalReports/standard/standardReportRequest';
import standardReportApi from '@/apis/externalReports/standard/standard_report';
import standardCarApi from '@/apis/externalReports/standard/standard_car';
import useSpeech from '@/composables/useSpeech';
import { useRequestGuard } from '@/composables/useRequestGuard';
import { useRoute } from '@/hooks/useRoute';

interface PostWorkState {
  showConfirmBaseArrivalModal: boolean;
  standardReport: StandardReport;
}
export default defineComponent({
  props: {
    standardCar: {
      type: Object as PropType<StandardReportCar>,
      required: true,
    },
    userSettings: {
      type: Object as PropType<ExternalReportSettings>,
      required: true,
    },
  },
  emits: [
    'updateCommonAndCarStatus',
    'editContentAndRoad',
    'showErrorOnCommon',
    'stopRunning',
  ],
  setup(props, { emit }) {
    const state = reactive<PostWorkState>({
      showConfirmBaseArrivalModal: false,
      standardReport: props.standardCar.report,
    });
    const { doSpeech } = useSpeech();
    const { router } = useRoute();
    const { doRequest, isRequesting } = useRequestGuard((errorMessage) => {
      emit('showErrorOnCommon', errorMessage);
    });

    const spLabels = computed<ExternalReportsLabelSp>(() => {
      return props.userSettings.sp;
    });

    const baseArrival = async() => {
      state.showConfirmBaseArrivalModal = false;
      const params: StandardReportBaseArrivalTsUpdateParams = {
        base_arrival_ts: new Date(),
      };
      await doRequest(async() => {
        state.standardReport = await standardReportApi.updateBaseArrival(state.standardReport.id, params);
        await standardCarApi.updateReportId(props.standardCar.id, { current_standard_report_id: null });
      }, '基地到着に失敗しました。再度操作を行ってください。');
      doSpeech(spLabels.value.message.confirm_complete_operation);
      emit('stopRunning', props.userSettings.choices.status.stopped.key, state.standardReport);
    };
    const editContentAndRoad = () => {
      emit('editContentAndRoad');
    };

    onMounted(() => {
      if (state.standardReport.id === 0) {
        router.push({name: 'Login'});
      }
    });

    return {
      state,
      isRequesting,
      spLabels,
      editContentAndRoad,
      baseArrival,
    };
  },
});
